import { createAsyncThunk } from '@reduxjs/toolkit'
import * as API_BOOKS from '../../shared/http/books'

export const fetchBooks = createAsyncThunk('books/fetchAll', () => API_BOOKS.getBooks())
